module.exports = __webpack_public_path__ + "img/arr.8143fc9d.svg";